import React, { Component } from 'react';
import { Form, Card, InputGroup, Row, Col } from 'react-bootstrap';
import clientAxios from '../../../clients/clientAxios';
import notify from 'react-notify-toast';
import { COMMISSION_STATES_FINISHED } from '../../../constants';
import './courseCard.css';

export default class CourseCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course: '',
      classroom: '',
      monthlyInstallments: null,
      price: '',
      isActive: '',
      downReason: ['', '', ''],
      otherDownReason: ['', '', ''],
      moduleDownReason: ['', '', ''],
      commissionChangedReason: ['', '', ''],
      otherCommissionChangedReason: ['', '', ''],
      moduleCommissionChangedReason: ['', '', ''],
      scholarship: false,
      changedInCommission: ['', '', ''],
      currency: 'ARS',
      plan: null,
      planes: [],
      showSpecialPlans: false,
      showFinishedCommissions: false,
      courses: [],
    };
  }

  componentDidMount() {
    this.getData();
    this.getCourses();
  }

  getCourses = async () => {
    try {
      const { data } = await clientAxios('/courses');
      this.setState({ courses: data });
    } catch (error) {
      notify.show('Error al cargar los cursos', 'error');
    }
  };
  componentDidUpdate(prevProps) {
    const currentClassroomProp =
      typeof this.props.classroom === 'object'
        ? this.props.classroom[this.props.cardId]
        : this.props.classroom;
    const prevClassroomProp =
      typeof prevProps.classroom === 'object'
        ? prevProps.classroom[prevProps.cardId]
        : prevProps.classroom;

    const currentStudentPlanForCard =
      this.props.plan && Array.isArray(this.props.plan)
        ? this.props.plan.find((p) => p?.classroom === currentClassroomProp)
            ?.planId
        : null;
    const prevStudentPlanForCard =
      prevProps.plan && Array.isArray(prevProps.plan)
        ? prevProps.plan.find((p) => p?.classroom === prevClassroomProp)?.planId
        : null;

    if (
      prevProps.cardId !== this.props.cardId ||
      currentClassroomProp !== prevClassroomProp ||
      currentStudentPlanForCard !== prevStudentPlanForCard
    ) {
      this.getData();
    }
  }

  getData = async () => {
    try {
      if (this.state.planes.length === 0) {
        const { data: planesData } = await clientAxios('/planes');
        this.setState({ planes: planesData || [] });
      }

      const selectedClassroomName =
        typeof this.props.classroom === 'object'
          ? this.props.classroom[this.props.cardId]
          : this.props.classroom;

      const classroomDataFromList = this.props.classroomList.find(
        (cr) => cr.classroom === selectedClassroomName
      );

      let initialPlanId = null;

      if (Array.isArray(this.props.plan)) {
        const studentPlanForCurrentClassroom = this.props.plan
          .filter(Boolean)
          .find((p) => p.classroom === selectedClassroomName);

        if (studentPlanForCurrentClassroom?.planId) {
          initialPlanId = studentPlanForCurrentClassroom.planId;
        }
      }
      if (!initialPlanId && classroomDataFromList?.plan) {
        if (
          typeof classroomDataFromList.plan === 'object' &&
          classroomDataFromList.plan.$oid
        ) {
          initialPlanId = classroomDataFromList.plan.$oid;
        } else if (typeof classroomDataFromList.plan === 'string') {
          initialPlanId = classroomDataFromList.plan;
        } else {
          initialPlanId = null;
        }
      } else if (
        !initialPlanId &&
        classroomDataFromList &&
        !classroomDataFromList.plan
      ) {
        initialPlanId = null;
      }

      const initialCourse = classroomDataFromList?.course || '';

      let monthlyInstallments =
        this.props.monthlyInstallments !== null &&
        typeof this.props.monthlyInstallments === 'object'
          ? this.props.monthlyInstallments[this.props.cardId]
          : this.props.monthlyInstallments;
      let price =
        this.props.price !== null && typeof this.props.price === 'object'
          ? this.props.price[this.props.cardId]
          : this.props.price;

      if (initialPlanId && this.state.planes.length > 0) {
        const planObj = this.state.planes.find((p) => p._id === initialPlanId);
        if (planObj && planObj.priceSchema && planObj.priceSchema.length > 0) {
          if (!price || price === '') {
            price = planObj.priceSchema[0];
          }
          if (!monthlyInstallments || monthlyInstallments === '') {
            monthlyInstallments = planObj.priceSchema.length;
          }
        } else {
          price = '';
          monthlyInstallments = null;
        }
      } else {
        price = '';
        monthlyInstallments = null;
      }

      const isActive =
        typeof this.props.isActive === 'object'
          ? this.props.isActive[this.props.cardId]
          : this.props.isActive;
      const downReason =
        typeof this.props.downReason === 'object'
          ? this.props.downReason[this.props.cardId]
          : this.props.downReason;
      const otherDownReason =
        typeof this.props.otherDownReason === 'object'
          ? this.props.otherDownReason !== null
            ? this.props.otherDownReason[this.props.cardId]
            : ['', '', '']
          : this.props.otherDownReason;
      const commissionChangedReason =
        typeof this.props.commissionChangedReason === 'object'
          ? this.props.commissionChangedReason[this.props.cardId]
          : this.props.commissionChangedReason;
      const otherCommissionChangedReason =
        typeof this.props.otherCommissionChangedReason === 'object'
          ? this.props.otherCommissionChangedReason !== null
            ? this.props.otherCommissionChangedReason[this.props.cardId]
            : ['', '', '']
          : this.props.otherCommissionChangedReason;
      const moduleDownReason =
        typeof this.props.moduleDownReason === 'object'
          ? this.props.moduleDownReason !== null
            ? this.props.moduleDownReason[this.props.cardId]
            : ['', '', '']
          : this.props.moduleDownReason;
      const moduleCommissionChangedReason =
        typeof this.props.moduleCommissionChangedReason === 'object'
          ? this.props.moduleCommissionChangedReason !== null
            ? this.props.moduleCommissionChangedReason[this.props.cardId]
            : ['', '', '']
          : this.props.moduleCommissionChangedReason;
      const changedInCommission =
        typeof this.props.changedInCommission === 'object'
          ? this.props.changedInCommission !== null
            ? this.props.changedInCommission[this.props.cardId]
            : ['', '', '']
          : this.props.changedInCommission;
      let currency =
        typeof this.props.currency === 'object'
          ? this.props.currency[this.props.cardId]
          : this.props.currency;

      if (!currency) {
        currency = 'ARS';
      }

      this.setState(
        {
          classroom: selectedClassroomName,
          monthlyInstallments,
          price,
          isActive,
          cardId: this.props.cardId,
          scholarship: Boolean(this.props.scholarship[this.props.cardId]),
          course: initialCourse,
          downReason,
          otherDownReason,
          moduleDownReason,
          commissionChangedReason,
          otherCommissionChangedReason,
          moduleCommissionChangedReason,
          changedInCommission,
          currency,
          plan: initialPlanId,
          showSpecialPlans: this.checkIsSpecialPlan(
            this.state.planes,
            initialPlanId
          ),
        },
        () => {
          this.props.handleSave(this.state);
        }
      );
    } catch (error) {
      console.error(error);
      notify.show('Error al cargar los planes o datos iniciales', 'error');
    }
  };

  closeCard = () => {
    this.props.handleClose();
  };

  handlePopulatePriceFromPlanSchema = (planId) => {
    const { planes } = this.state;

    if (planes?.length > 0 && planId) {
      const selectedPlan = planes.find(({ _id }) => _id === planId);

      if (
        selectedPlan &&
        selectedPlan.priceSchema &&
        selectedPlan.priceSchema.length > 0
      ) {
        this.setState({
          price: selectedPlan.priceSchema[0],
          monthlyInstallments: selectedPlan.priceSchema.length,
        });
      } else {
        this.setState({ price: '', monthlyInstallments: null });
      }
    } else {
      this.setState({ price: '', monthlyInstallments: null });
    }
  };

  handleChange = (obj) => {
    let { name, value, type, checked } = obj.target;
    let newState = {};

    if (name === 'classroom') {
      const newClassroomData = this.props.classroomList.find(
        (cr) => cr.classroom === value
      );

      newState.classroom = value;
      newState.course = newClassroomData?.course || '';
      newState.changedInCommission = this.state.classroom;

      let newPlanId = null;
      if (newClassroomData?.plan) {
        if (
          typeof newClassroomData.plan === 'object' &&
          newClassroomData.plan.$oid
        ) {
          newPlanId = newClassroomData.plan.$oid;
        } else if (typeof newClassroomData.plan === 'string') {
          newPlanId = newClassroomData.plan;
        } else {
          newPlanId = null;
        }
      } else {
        newPlanId = null;
      }

      newState.plan = newPlanId;

      this.handlePopulatePriceFromPlanSchema(newPlanId);

      this.setState(newState, () => {
        this.props.handleSave(this.state);
      });
    } else if (name === 'plan') {
      newState.plan = value === '' ? null : value;
      this.handlePopulatePriceFromPlanSchema(newState.plan);
      this.setState(newState, () => {
        this.props.handleSave(this.state);
      });
    } else if (type === 'checkbox') {
      this.setState({ [name]: checked }, () => {
        this.props.handleSave(this.state);
      });
    } else {
      this.setState({ [name]: value }, () => {
        this.props.handleSave(this.state);
      });
    }
  };

  toggleShowSpecialPlans = () => {
    this.setState((prevState) => ({
      showSpecialPlans: !prevState.showSpecialPlans,
    }));
  };

  toggleShowFinishedCommissions = () => {
    this.setState((prevState) => {
      const newShowFinished = !prevState.showFinishedCommissions;
      this.props.onToggleShowFinished(newShowFinished);
      return { showFinishedCommissions: newShowFinished };
    });
  };



  checkIsSpecialPlan(
    planesToCheck = this.state.planes,
    planIdToCheck = this.state.plan
  ) {
    const selectedPlan = planesToCheck?.find(
      (item) => item._id === planIdToCheck
    );
    return selectedPlan?.specialPlan || false;
  }

  render() {
    return (
      <Card className="p-3 mx-3 mb-3 shadow">
        <Form.Group>
          <Form.Label className="w-100">
            <Row>
              <Col>
                Curso<strong className="text-danger">*</strong>
              </Col>
              <Col className="text-right">
                <i
                  onClick={() => this.props.handleClose(this.props.cardId)}
                  className="fas fa-times text-danger"
                />
              </Col>
            </Row>
          </Form.Label>

          <Form.Control
            as="select"
            name="course"
            onChange={this.handleChange}
            disabled
            value={this.state?.course}
          >
            <option value="">Esta comisión no tiene un curso asignado</option>
            {this.state?.courses.map((course, index) => (
              <option key={index} value={course.name || course}>
                {course.name || course}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Row>
            <Col className="d-flex align-items-center">
              <Form.Label className="pe-2 mb-0">
                Mostrar solo planes especiales
              </Form.Label>
              <Form.Check
                type={'checkbox'}
                className="mx-2 custom-checkbox"
                onChange={this.toggleShowSpecialPlans}
                checked={this.state.showSpecialPlans}
              />
            </Col>
          </Row>
        </Form.Group>
        <Form.Group>
          <Row>
            <Col className="d-flex align-items-center mt-2">
              <Form.Label className="pe-2 mb-0">
                Mostrar comisiones finalizadas
              </Form.Label>
              <Form.Check
                type={'checkbox'}
                className="mx-2 custom-checkbox"
                onChange={this.toggleShowFinishedCommissions}
                checked={this.state.showFinishedCommissions}
              />
            </Col>
          </Row>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Comisión<strong className="text-danger">*</strong>
          </Form.Label>

          <Form.Control
            as="select"
            name="classroom"
            onChange={this.handleChange}
            value={this.state.classroom}
          >
            <option value="">Seleccione una opción...</option>
            {this.props.classroomList
              .filter((item) => 
                this.state.showFinishedCommissions 
                  ? item.isActive === COMMISSION_STATES_FINISHED.FINISHED
                  : item.isActive !== COMMISSION_STATES_FINISHED.FINISHED
              )
              .map((item, i) => (
                <option data-index={item.course} key={i} value={item.classroom}>
                  {item.classroom}
                </option>
              ))}
          </Form.Control>
        </Form.Group>

        <Form.Group>
          <Form.Label>
            Plan de Pagos<strong className="text-danger">*</strong>
          </Form.Label>
          <Form.Control
            as="select"
            name="plan"
            onChange={this.handleChange}
            value={this.state.plan || ''}
          >
            <option value="">Sin plan</option>
            {this.state.planes?.map((item, i) => {
              if (
                (item?.specialPlan !== true &&
                  this.state.showSpecialPlans === false) ||
                (item?.specialPlan === true &&
                  this.state.showSpecialPlans === true)
              ) {
                return (
                  <option data-index={item._id} key={i} value={item._id}>
                    {item?.description}
                  </option>
                );
              }
              return null;
            })}
          </Form.Control>
        </Form.Group>

        <Form.Group>
          <Form.Label>Cantidad de cuotas</Form.Label>
          <Form.Control
            min={1}
            type="number"
            name="monthlyInstallments"
            required
            onChange={this.handleChange}
            value={this.state.monthlyInstallments || ''}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Tipo de moneda</Form.Label>

          <Form.Control
            as="select"
            name="currency"
            onChange={this.handleChange}
            value={this.state.currency}
          >
            <option value="" hidden>
              Seleccione una moneda...
            </option>
            <option data-index={'ARS'} key={'ARS'} value={'ARS'}>
              ARS
            </option>
            <option data-index={'USD'} key={'USD'} value={'USD'}>
              USD
            </option>
            <option data-index={'EUR'} key={'EUR'} value={'EUR'}>
              EUR
            </option>
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Estado<strong className="text-danger">*</strong>
          </Form.Label>
          <Form.Control
            as="select"
            name="isActive"
            onChange={this.handleChange}
            value={this.state.isActive}
            required
            disabled={!this.state.classroom}
          >
            <option value="" hidden>
              Seleccione una comisión...
            </option>
            <option value="prepay">Señado</option>
            <option value="up">Activo</option>
            <option value="posibleDown">Posible baja</option>
            <option value="down">Baja</option>
            <option value="done">Finalizo cursado</option>
            <option value="commissionChanged">Cambio de comisión</option>
          </Form.Control>
          {this.state.isActive === 'down' ? (
            <>
              <Form.Label className="mt-3">Motivo de la baja</Form.Label>
              <Form.Group>
                <Form.Control
                  as="select"
                  type="text"
                  name="downReason"
                  onChange={this.handleChange}
                  value={this.state.downReason}
                >
                  <option value="" hidden>
                    Escriba el motivo de la baja
                  </option>
                  <option value="lackTime">Falta de tiempo</option>
                  <option value="disease">Enfermedad</option>
                  <option value="workProblems">Laborales</option>
                  <option value="economicProblems">Económicas</option>
                  <option value="disagreementDictation">
                    Disconformidad con el dictado
                  </option>
                  <option value="others">Otros</option>
                </Form.Control>
              </Form.Group>
              {this.state.downReason === 'others' ? (
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese el motivo"
                    name="otherDownReason"
                    onChange={this.handleChange}
                    value={this.state.otherDownReason}
                    className="mb-3"
                  />
                </InputGroup>
              ) : null}
              <Form.Label>Modulo de la baja</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Ingrese el modulo"
                  name="moduleDownReason"
                  onChange={this.handleChange}
                  value={this.state.moduleDownReason}
                />
              </InputGroup>
            </>
          ) : this.state.isActive === 'commissionChanged' ? (
            <>
              <Form.Label className="mt-3">Motivo del cambio</Form.Label>
              <Form.Group>
                <Form.Control
                  as="select"
                  type="text"
                  name="commissionChangedReason"
                  onChange={this.handleChange}
                  value={this.state.commissionChangedReason}
                >
                  <option value="" hidden>
                    Escriba el motivo del cambio
                  </option>
                  <option value="lackTime">Falta de tiempo</option>
                  <option value="disease">Enfermedad</option>
                  <option value="workProblems">Laborales</option>
                  <option value="economicProblems">Económicas</option>
                  <option value="disagreementDictation">
                    Disconformidad con el dictado
                  </option>
                  <option value="others">Otros</option>
                </Form.Control>
              </Form.Group>
              {this.state.commissionChangedReason === 'others' ? (
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese el motivo"
                    name="otherCommissionChangedReason"
                    onChange={this.handleChange}
                    value={this.state.otherCommissionChangedReason}
                    className="mb-3"
                  />
                </InputGroup>
              ) : null}
              <Form.Label>Modulo del cambio</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Ingrese el modulo"
                  name="moduleCommissionChangedReason"
                  onChange={this.handleChange}
                  value={this.state.moduleCommissionChangedReason}
                />
              </InputGroup>
            </>
          ) : null}
        </Form.Group>

        <Form.Group className="border rounded p-2">
          <Form.Check
            type="checkbox"
            checked={this.state.scholarship}
            onChange={this.handleChange}
            name="scholarship"
            label="Curso becado"
          />
        </Form.Group>
      </Card>
    );
  }
}
